import { elevation, themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import * as React from "react";
import { css } from "styled-components";

export interface SkipNavStyles {
    skipToContent?: ButtonPresentationProps;
}

export const skipNavStyles: SkipNavStyles = {
    skipToContent: {
        variant: "tertiary",
        css: css`
        margin: 7px;
        position: absolute;
        clip: rect(0, 0, 0, 0);
            &:focus,
            &:focus-visible {
                clip: unset;
                z-index: 1;
                ${TypographyStyle} {
                    color: ${themeColors.secondary.danaBrightBlue};
                    border: none;
                    outline: none;
                }
            }

        &:focus,
        &:focus-visible {
            outline: none;
            border: 1px solid ${themeColors.primary.white};
            box-shadow: ${elevation.focus};
        }

        &:hover {
            color: ${themeColors.secondary.danaBrightBlue};
            border: none;
            outline: none;
            box-shadow: none;
        }

        &:disabled {
            ${TypographyStyle} {
                color: ${themeBackgrounds.darkGray};
            }
        }
    `,
    },
};

interface OwnProps {
    text: string;
    destination?: React.RefObject<HTMLElement>;
    extendedStyles?: SkipNavStyles;
    focusFunction?: () => void;
}

const SkipNav: React.FC<OwnProps> = (props: OwnProps) => {
    const [styles] = React.useState(() => mergeToNew(skipNavStyles, props.extendedStyles));
    if (props.focusFunction) {
        return (
            <Button className="text-body-sm" {...styles.skipToContent} onClick={props.focusFunction}>
                {props.text}
            </Button>
        );
    }
    return (
        <Button className="text-body-sm" {...styles.skipToContent} onClick={() => props.destination?.current?.focus()}>
            {props.text}
        </Button>
    );
};

export default SkipNav;
